/* KHAVIYAR UGC reel controller (25 Oct 2026).
   Every <video data-kh-ugc> loads only when it is about to scroll into view, plays muted and looping
   while at least half of it is on screen, and pauses when it leaves. Slow or data-saver connections
   get the 480p rendition. A tap turns sound on for that clip and mutes every other one. If the OS
   refuses autoplay (iOS Low Power Mode) the tile shows a play button and a tap starts it.
   kh-video-guard.js skips these videos so it never forces them to preload or resume. */
(function () {
  'use strict';
  if (window.KHUGC) { window.KHUGC.scan(); return; }
  var conn = navigator.connection || {};
  var slow = !!conn.saveData || /(^|-)(2g|3g)$/.test(conn.effectiveType || '');
  var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  var onScreen = new Set();
  var near = null, vis = null;

  function tile(v) { return v.closest ? v.closest('[data-kh-ugc-tile]') : null; }
  function load(v) {
    if (!v || v.dataset.khLoaded === '1') return;
    var s = (slow && v.dataset.srcSd) || v.dataset.src || v.dataset.srcSd;
    if (!s) return;
    v.dataset.khLoaded = '1';
    // The 720p and 480p URLs are derived from the 1080p name in the tile snippet. If one is ever
    // missing, fall back to the 1080p original once rather than leaving a dead tile.
    v.addEventListener('error', function () {
      var full = v.dataset.srcFull;
      if (!full || v.dataset.khFell === '1') return;
      v.dataset.khFell = '1';
      v.src = full;
      try { v.load(); } catch (e) {}
      if (onScreen.has(v)) play(v);
    });
    v.preload = slow ? 'metadata' : 'auto';
    v.src = s;
    try { v.load(); } catch (e) {}
  }
  // Tiles past the rail's edge are clipped, so the near-observer cannot see them coming. Buffer the
  // next clip as soon as one starts playing, so a swipe or arrow tap lands on a clip that is ready.
  function loadNext(v) {
    var t = tile(v), n = t && t.nextElementSibling;
    while (n && !(n.matches && n.matches('[data-kh-ugc-tile]'))) n = n.nextElementSibling;
    if (n) load(n.querySelector('video[data-kh-ugc]'));
  }
  function play(v) {
    load(v);
    if (reduce && v.dataset.khUser !== '1') { var r = tile(v); if (r) r.classList.add('is-blocked'); return; }
    var t = tile(v), p;
    try { p = v.play(); } catch (e) {}
    if (p && p.then) {
      p.then(function () { if (t) { t.classList.remove('is-blocked'); t.classList.add('is-playing'); } if (!slow) loadNext(v); })
       .catch(function () { if (t) t.classList.add('is-blocked'); });
    }
  }
  function pause(v) {
    try { v.pause(); } catch (e) {}
    var t = tile(v);
    if (t) t.classList.remove('is-playing');
  }
  function setSound(v, on) {
    var t = tile(v);
    if (!t) return;
    t.classList.toggle('is-sound', on);
    var b = t.querySelector('[data-kh-ugc-sound]');
    if (b) { b.setAttribute('aria-pressed', on ? 'true' : 'false'); b.setAttribute('aria-label', on ? 'Turn sound off' : 'Turn sound on'); }
  }
  function muteOthers(keep) {
    document.querySelectorAll('video[data-kh-ugc]').forEach(function (o) {
      if (o !== keep && !o.muted) { o.muted = true; setSound(o, false); }
    });
  }

  function scan() {
    document.querySelectorAll('video[data-kh-ugc]').forEach(function (v) {
      if (v.dataset.khUgcOn === '1') return;
      v.dataset.khUgcOn = '1';
      v.muted = true; v.defaultMuted = true; v.playsInline = true;
      if (near && vis) { near.observe(v); vis.observe(v); }
      else { load(v); play(v); }
    });
  }

  if ('IntersectionObserver' in window) {
    near = new IntersectionObserver(function (es) {
      es.forEach(function (e) { if (e.isIntersecting) { load(e.target); near.unobserve(e.target); } });
    }, { rootMargin: '500px 600px' });
    vis = new IntersectionObserver(function (es) {
      es.forEach(function (e) {
        if (e.isIntersecting && e.intersectionRatio >= 0.5) { onScreen.add(e.target); if (!document.hidden) play(e.target); }
        else { onScreen.delete(e.target); pause(e.target); }
      });
    }, { threshold: [0, 0.5] });
  }

  document.addEventListener('click', function (e) {
    var t = e.target;
    if (!t || !t.closest) return;
    var nav = t.closest('[data-kh-ugc-nav]');
    if (nav) {
      var reel = nav.closest('[data-kh-ugc-reel]');
      var rail = reel && reel.querySelector('[data-kh-ugc-rail]');
      var first = rail && rail.querySelector('[data-kh-ugc-tile]');
      if (rail && first) {
        var step = first.getBoundingClientRect().width + 12;
        rail.scrollBy({ left: nav.getAttribute('data-kh-ugc-nav') === 'prev' ? -step : step, behavior: reduce ? 'auto' : 'smooth' });
      }
      return;
    }
    var tl = t.closest('[data-kh-ugc-tile]');
    if (!tl) return;
    var v = tl.querySelector('video[data-kh-ugc]');
    if (!v) return;
    e.preventDefault();
    v.dataset.khUser = '1';
    if (v.paused) { v.muted = false; muteOthers(v); setSound(v, true); play(v); return; }
    var turnOn = v.muted;
    v.muted = !turnOn;
    if (turnOn) { v.volume = 1; muteOthers(v); }
    setSound(v, turnOn);
  });

  document.addEventListener('visibilitychange', function () {
    if (document.hidden) { document.querySelectorAll('video[data-kh-ugc]').forEach(pause); }
    else { onScreen.forEach(play); }
  });
  window.addEventListener('pageshow', function () { onScreen.forEach(play); });

  if ('MutationObserver' in window) {
    var queued = false;
    new MutationObserver(function () {
      if (queued) return;
      queued = true;
      setTimeout(function () { queued = false; scan(); }, 120);
    }).observe(document.documentElement, { childList: true, subtree: true });
  }
  document.addEventListener('shopify:section:load', scan);
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', scan); else scan();
  window.KHUGC = { scan: scan };
})();
